import { render, staticRenderFns } from "./CostType copy.vue?vue&type=template&id=cef4feec&scoped=true&"
import script from "./CostType copy.vue?vue&type=script&lang=js&"
export * from "./CostType copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef4feec",
  null
  
)

component.options.__file = "CostType copy.vue"
export default component.exports